import request from '../utils/request'

export function saveSignupMember(data) { // 考试人员新增
  return request({
    url: '/api/signupMembers/save',
    method: 'POST',
    data
  })
}

export function signupMemberInfo(params) { // 考试人员资料信息
  return request({
    url: '/api/signupMembers/info',
    method: 'GET',
    params
  })
}
